export class AboutUsPage {
    // static EventListeners = {
    //     'ShoptetDOMPageContentLoaded': AboutUsPage.doLoadOnShoptetDOMPageContentLoaded,
    // }
    // static doLoadOnShoptetDOMPageContentLoaded() {}
    // static doLoadOnShoptetDOMPageMoreProductsLoaded() {}
    // static doLoadOnShoptetDOMContentLoaded() {}
    // static doLoadOnChange() {}
    static async doInit() {
        AboutUsPage.doStyleMisc();
        return true;
    }

    static doStyleMisc() {
        $('body').addClass('in-o-nas');

        const currentLang = document.querySelector('html').getAttribute('lang');
        if(currentLang === 'cs') {
            $('.advantages .advantage.advantage-4 .img.triangle').addClass('cs');
        }
        // $('body').addClass('in-o-nas');
        // $(".fotogalery-sneak .images").load("/o-projektu/ .plus-gallery-wrap");
    }
}
